import { Component, Injectable, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Response } from '@angular/http';

import { AdministrationService } from 'app/services/administration.service';
import { AlertService } from 'app/utils/alert.service';
import { DataPackUserManagerModel } from 'app/models/data.manager.model';
import { DataPackGroup } from 'app/models/dataPackGroup.model';

  import * as _ from "lodash";

@Component({
  selector: 'editAdministrator',
  templateUrl: './content.modal.template.html',

})

/**
 * @version $Id: content.component.ts 90689 2018-05-09 17:26:14Z bernardo.d.siqueira $
 */
@Injectable()
export class EditAdministratorComponent {

  @Input() model: DataPackUserManagerModel;
  @Input() groups: Array<DataPackGroup> = [];
  @Input() hasData: boolean;

  private form: FormGroup;
  private saving: boolean;
  private associatedGroups: Array<DataPackGroup> = [];

  constructor(private activeModal: NgbActiveModal, private formBuilder: FormBuilder, private adminService: AdministrationService, private alertService: AlertService) {

  }

  ngOnInit() {
    this.saving = false;
    if (!this.model.profile) {
      this.model.profile = 'Master';
    }
    this.form = this.formBuilder.group({
      name: [this.model.name, Validators.compose([Validators.required, Validators.maxLength(80)])],
      login: [{ value: this.model.login, disabled: !_.isNil(this.model.login) }, Validators.compose([Validators.required, Validators.maxLength(15), Validators.pattern('^[a-zA-Z0-9._]+[a-zA-Z0-9]+([a-zA-Z0-9]+)*$')])],
      email: [this.model.email, Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$')])],
      telNumber: [this.model.telNumber, Validators.compose([Validators.required, Validators.pattern('0\\d{11}')])],
      profile: [{ value: this.model.profile, disabled: !_.isNil(this.model.login) }, Validators.required],
      sendEmail: [this.model.sendEmail],
      dataPackGroup: [{ value: '', disabled: this.model.profile === 'Master' }]
    });
    this.associatedGroups = this.model.dataPackGroupList || [];
    this.groups = _.clone(this.groups);
    if (!this.hasData) {
      this.form.controls['sendEmail'].disable();
    }

  }

  ngAfterViewInit() {
    this.profileChanged(this.model.profile);
  }

  private isFormValid() {
    let valid = true;
    let keyName;
    if (this.saving){
      valid = false;
    }
    if(this.form.controls['profile'].value === 'Gestor' && this.associatedGroups.length === 0){
      valid = false;
    }
    Object.keys(this.form.controls).forEach(key => {
      if (!this.form.controls[key].valid && !this.form.controls[key].disabled) {
        valid = false;
        keyName = key;
      }
    });
    return valid;
  }

  private close() {
    this.activeModal.dismiss();
  }

  private profileChanged(value: string) {
    this.form.controls['profile'].setValue(value);
    if (!_.isNil(this.model.login)) {
      this.form.controls['profile'].disable();
    }
    if (this.form.controls['profile'].value === 'Master') {
      this.form.controls['dataPackGroup'].disable();
      this.form.controls['dataPackGroup'].setValue('');
    } else {
      this.form.controls['dataPackGroup'].enable();
    }
  }

  private save() {
    this.saving = true;
    let payload = this.form.getRawValue();
    payload.action = this.model.login ? 'edit' : 'create';
    payload.dataPackGroupList = [];
    this.associatedGroups.forEach((associatedGroup) => {
      let group = new DataPackGroup();
      group.id = associatedGroup.id;
      payload.dataPackGroupList.push(group);
    });
    delete payload.dataPackGroup;
    this.adminService.edit(payload).subscribe(
      data => {
        this.saving = false;
        this.activeModal.close();
        this.alertService.success(data['result']);
      },
      err => {
        this.saving = false;
        this.activeModal.close();
        this.alertService.error(err.result, err);
      }
    );
  }

  private addGroup() {
    let selectedGroupId = this.form.controls['dataPackGroup'].value;
    if (selectedGroupId !== '') {
      let removedGroups = _.remove(this.groups, (group) => {
        return Number(group.id) === _.toNumber(selectedGroupId);
      });
      if (removedGroups.length > 0) {
        this.associatedGroups.push(removedGroups[0]);
      }
    }
  }

  private removeGroup(group: DataPackGroup) {
    let removedGroups = _.remove(this.associatedGroups, (associatedGroup) => {
      return associatedGroup.id === group.id;
    });
    if (removedGroups.length > 0) {
      this.groups.push(removedGroups[0]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/administration/save/content.component.ts